import { render } from "./VideosItem.vue?vue&type=template&id=7b1d8b97"
import script from "./VideosItem.vue?vue&type=script&lang=js"
export * from "./VideosItem.vue?vue&type=script&lang=js"

import "./VideosItem.vue?vue&type=style&index=0&id=7b1d8b97&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__